<div class="dropdown">
  <div (click)="onOpen()">
    <ng-content select="[dropdown-value]"></ng-content>
  </div>
  <ng-template #overlayContentTemplate>
    <div class="tw-w-full tw-h-full" (click)="onOpen()">
      <div class="content">
        <ng-content select="[dropdown-list]"></ng-content>
      </div>
    </div>
  </ng-template>
</div>
